import { useMutation, UseMutationOptions } from 'react-query'
import { AxiosError } from 'axios'
import axios from 'axios'
import { useAuth0 } from 'app/Auth'

export interface PatientPhysicianPayload {
  patient_mrn: string
  physician_first_name: string
  physician_last_name: string
  physician_phone: string
  physician_email: string
  physician_salutation: string
}

export interface PatientPhysicianResponse {
  success: boolean
  message: string
  data?: {
    patient_id: string
    physician_id: string
  }
}

const patientPhysicianMutationFn = async (
  payload: PatientPhysicianPayload,
  getAccessToken: () => Promise<string>
): Promise<PatientPhysicianResponse> => {
  const token = await getAccessToken()
  const REPORTS_URL = process.env.REACT_APP_REPORTS_URL

  if (!REPORTS_URL) {
    throw new Error(
      'REACT_APP_REPORTS_URL is not defined in environment variables.'
    )
  }

  const response = await axios.post<PatientPhysicianResponse>(
    `${REPORTS_URL}api/v1/patient-physician`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  )
  return response.data
}

export const usePatientPhysician = (
  options?: UseMutationOptions<
    PatientPhysicianResponse,
    AxiosError,
    PatientPhysicianPayload
  >
) => {
  const { getAccessToken } = useAuth0()

  return useMutation<
    PatientPhysicianResponse,
    AxiosError,
    PatientPhysicianPayload
  >(
    (data: PatientPhysicianPayload) =>
      patientPhysicianMutationFn(data, getAccessToken),
    options
  )
}
